import { z } from "zod";
import { MeetingSchema } from "../../models/meeting.schema";

export const PrivateMeetingControllerResponseSchema = {
  publishMeeting: z.object({
    success: z.boolean(),
    errors: z.string().array(),
  }),

  sendToLaserfiche: z.object({
    success: z.boolean(),
    errors: z.string().array(),
  }),

  mailMeetingPdf: z.boolean(),

  listMeetings: MeetingSchema.array(),

  getMeeting: MeetingSchema.nullable(),

  createMeeting: MeetingSchema,

  updateMeeting: MeetingSchema,

  deleteMeeting: z.void(),
};
